import Vue from 'vue'
import Modal from '@/components/Modal.vue'

// 创建 Modal 构造器
const ModalConstructor = Vue.extend(Modal)

let modalInstance = null

function createModal() {
  if (modalInstance) {
    return modalInstance
  }
  
  // 使用 $mount 而不是 el
  modalInstance = new ModalConstructor()
  modalInstance.$mount()
  document.body.appendChild(modalInstance.$el)
  return modalInstance
}

function showModal(options = {}) {
  const instance = createModal()
  instance.show(options)
  return instance
}

// 快捷方法
const ModalPlugin = {
  // 信息提示
  info(message, title = '提示') {
    return showModal({
      title,
      message,
      type: 'info'
    })
  },
  
  // 成功提示
  success(message, title = '成功') {
    return showModal({
      title,
      message,
      type: 'success'
    })
  },
  
  // 错误提示
  error(message, title = '错误') {
    return showModal({
      title,
      message,
      type: 'error'
    })
  },
  
  // 警告提示
  warning(message, title = '警告') {
    return showModal({
      title,
      message,
      type: 'warning'
    })
  },
  
  // 确认对话框
  confirm(message, title = '确认', options = {}) {
    return new Promise((resolve, reject) => {
      showModal({
        title,
        message,
        type: options.type || 'info',
        showCancel: true,
        confirmText: options.confirmText || '确定',
        cancelText: options.cancelText || '取消',
        onConfirm: () => {
          resolve(true)
        },
        onCancel: () => {
          reject(false)
        }
      })
    })
  },
  
  // 自定义弹窗
  show(options) {
    return showModal(options)
  },
  
  // 关闭弹窗
  close() {
    if (modalInstance) {
      modalInstance.hide()
    }
  }
}

// 安装插件
ModalPlugin.install = function(Vue) {
  Vue.prototype.$modal = ModalPlugin
}

export default ModalPlugin

